<script>
  import Author from "./sub-components/Author.svelte";
  import {fetchAuthors} from "../api/authors";
</script>

<div id="anchor-authors" class="container-fluid block mb-4">
    <div class="row box w-100">
        <h1 class="title pt-3 text-left col-10 col-lg-8 offset-1 offset-lg-2">
            O autorach
        </h1>
        <div class="col-12 col-md-8 offset-md-2">
            {#await fetchAuthors() then authors}
                {#each authors as author, index}
                    <Author
                            image={author.image}
                            name={author.name}
                            description={author.description}
                            reversed={index % 2 === 1}
                    />
                {/each}
            {/await}
        </div>
    </div>
</div>

<style>
    .box {
        margin: 0 !important;
    }

    .block {
        min-height: 100vh;
        padding: 0 !important;
        display: flex;
        justify-content: center;
        flex-direction: column;
    }

    .title {
        font-family: "Montserrat";
        font-style: normal;
        font-weight: bold;
        font-size: 36px;
    }
</style>
